import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'volume-4', 'Volume4', [["g",{"transform":"translate(1.5, 0)","key":"svg-0"}]]);